import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import {
  BrowserRouter as Router
} from 'react-router-dom';
import config from "./config.js";
import Auth0Provider from './auth0-provider'

ReactDOM.render(
      < Router >
        <Auth0Provider>
            <React.StrictMode>
              <App />
            </React.StrictMode>
        </Auth0Provider> 
      </Router>,

  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
